import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useProjectsList } from '../../../../../contexts/ProjectsContext';
import FormInput from '../../../../shared/components/ui/FormInput';
import { useForm } from 'react-hook-form';
import { setActiveTab } from '../../../../../uiSlice';
import CommonTaskTable from './CommonTaskTable';
import IndependentTaskTable from './IndependentTaskTable';
import GroupTaskTable from './GroupTaskTable';

const subTabs = [
  { key: 'commonTask', label: 'Common Task' },
  { key: 'independentAccommodation', label: 'Independent Task (Accommodation)' },
  { key: 'groupAccommodation', label: 'Group Task (Accommodation)' }
];

const liveTasksTabBySubTab = {
  commonTask: 'commonTasks',
  independentAccommodation: 'independentAccommodation',
  groupAccommodation: 'groupAccommodation'
};

const MyTask = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeSubTab, setActiveSubTab] = useState('commonTask');
  const { projects, projectsForDropdown } = useProjectsList();
  const { register, watch, setValue } = useForm();

  const selectedProject = watch('project');

  useEffect(() => {
    if (projects?.length) {
      const projectId = location.state?.projectID || projects[0].id;
      setValue('project', projectId);
    }
  }, [projects, location.state?.projectID, setValue]);

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'commonTask':
        return <CommonTaskTable projectId={selectedProject} />;
      case 'independentAccommodation':
        return <IndependentTaskTable projectId={selectedProject} />;
      case 'groupAccommodation':
        return <GroupTaskTable projectId={selectedProject} />;
      default:
        return <CommonTaskTable projectId={selectedProject} />;
    }
  };

  return (
    <div>
      <div className="py-2 sticky top-[4.1rem] z-20 bg-white px-6 border-t border-b border-gray-200 shadow-sm flex items-center justify-between">
        <div className="flex gap-6 px-6">
          {subTabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveSubTab(tab.key)}
              className={`py-3 text-sm font-semibold transition-colors duration-200 relative ${
                activeSubTab === tab.key ? 'text-[#2A565E]' : 'text-gray-400 hover:text-gray-600'
              }`}>
              {tab.label}
              {activeSubTab === tab.key && (
                <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#2A565E] transition-all duration-300" />
              )}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={() => {
              dispatch(setActiveTab(liveTasksTabBySubTab[activeSubTab]));
              navigate('/builder/operations/tasks');
            }}
            className="px-4 py-2 rounded-[8px] text-sm font-medium bg-[#2A565E] text-white border border-[#2A565E] transition-all duration-200 hover:opacity-95">
            Create
          </button>
          <div className="flex items-center gap-2">
            <span className="text-md font-semibold text-gray-500 whitespace-nowrap">Project : </span>
            <div className="w-[min(240px,40vw)]">
              <FormInput
                width={100}
                label=""
                register={register}
                register_key="project"
                isRequired={true}
                type="dropdown"
                options={[{ label: 'Select Project', value: '', disabled: true }, ...projectsForDropdown]}
                hideAstrik={true}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="p-6">{renderSubTabContent()}</div>
    </div>
  );
};

export default MyTask;
